import script from "./UserAccountsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAccountsCard.vue?vue&type=script&setup=true&lang=js"

import "./UserAccountsCard.vue?vue&type=style&index=0&id=01c78120&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01c78120"]])

export default __exports__